module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_vm._v("正在加载...")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32ed7e6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 44
// module chunks = 0